import Component from '../core/Component'
import EventBus from '../core/EventBus'

export default class VisitLog extends Component {
    prepare() {
        EventBus.on('swup:clicklink', this.handleLinkClick)
        logVisit({
            url: window.location.href,
            ref: 'pageload',
        })
    }

    handleLinkClick = ({ target }) => {
        logElement(target)
    }
}

export const logElement = (element) => {
    const anchor = element.closest('a')

    if (!anchor) {
        return
    }

    const regionElement = element.closest('[data-log-region]')
    const region = regionElement ? regionElement.dataset.logRegion : 'unspecified'

    logVisit({
        url: anchor.href,
        ref: anchor.dataset.logRef || region,
    })
}

export const logVisit = ({ url, ref }) => {
    const data = new FormData()
    data.append('url', url.replace(window.location.origin, ''))
    data.append('ref', ref)

    setTimeout(() => {
        fetch('/visit-log', {
            method: 'POST',
            body: data,
        })
    }, 0)
}
